/** 效果注册表 + 元信息。键 = WorldEvent 枚举(与神谕/模拟器一致)。 */
import type { OracleEffect } from './base';
import { RainEffect } from './e01_rain';
import { FireworksEffect } from './e04_fireworks';
import { SkyColorEffect } from './e08_skyColor';
import { EpochAscendEffect } from './e14_epochAscend';
import { SkySplitEffect } from './e18_skySplit';
import { SnowEffect, WindEffect, RainbowEffect, MeteorEffect, DanceEffect } from './light2';
import { AuroraEffect, ThunderstormEffect, DayNightFlipEffect, LifeTideEffect, WhaleEffect } from './mid';
import { StatueRiseEffect, WorldTreeEffect, MeteorShowerEffect } from './grand';
import { DarkCloudEffect } from './safety';

type Ctor = new () => OracleEffect;

/** 全 19 张神迹卡。键 = WorldEvent 枚举。 */
export const EFFECT_CLASSES: Record<string, Ctor> = {
  rain: RainEffect, snow: SnowEffect, wind: WindEffect, fireworks: FireworksEffect,
  rainbow: RainbowEffect, meteor: MeteorEffect, dance: DanceEffect, sky_color: SkyColorEffect,
  aurora: AuroraEffect, thunderstorm: ThunderstormEffect, day_night_flip: DayNightFlipEffect,
  life_tide: LifeTideEffect, whale: WhaleEffect,
  epoch_leap: EpochAscendEffect, statue: StatueRiseEffect, world_tree: WorldTreeEffect, meteor_shower: MeteorShowerEffect,
  sky_split: SkySplitEffect, dark_cloud: DarkCloudEffect,
};

export const DEFAULT_DUR: Record<string, number> = {
  // 2026-07-18 全表收敛:rain 30/snow 45 等长时长 + 6s 收尾 + 天色 10s 缓出,
  // 单次体感接近一分钟,用户实测"出一次下雨一直下雨"。轻神迹应是"一阵",
  // 不是"一场";要持续天气靠弹幕合力续命,不靠单发超长。
  rain: 16, snow: 20, wind: 12, fireworks: 8, rainbow: 12, meteor: 1.8, dance: 14, sky_color: 15,
  aurora: 22, thunderstorm: 18, day_night_flip: 12, life_tide: 12, whale: 14,
  epoch_leap: 8, statue: 12, world_tree: 15, meteor_shower: 20, sky_split: 22, dark_cloud: 10,
};

export const EFFECT_META: Record<string, { label: string; tier: string }> = {
  rain: { label: '落雨', tier: '轻' }, snow: { label: '落雪', tier: '轻' }, wind: { label: '起风', tier: '轻' },
  fireworks: { label: '烟花', tier: '轻' }, rainbow: { label: '彩虹', tier: '轻' }, meteor: { label: '流星', tier: '轻' },
  dance: { label: '共舞', tier: '轻' }, sky_color: { label: '天染', tier: '轻' },
  aurora: { label: '极光', tier: '中' }, thunderstorm: { label: '雷暴', tier: '中' }, day_night_flip: { label: '昼夜逆转', tier: '中' },
  life_tide: { label: '生命潮汐', tier: '中' }, whale: { label: '巨鲸掠空', tier: '中' },
  epoch_leap: { label: '纪元跃迁', tier: '大' }, statue: { label: '神像落成', tier: '大' },
  world_tree: { label: '世界树', tier: '大' }, meteor_shower: { label: '流星雨', tier: '大' },
  sky_split: { label: '天空撕裂', tier: '戏剧' }, dark_cloud: { label: '乌云(兜底)', tier: '安全' },
};
